import React from 'react';
import { Row, Col } from 'reactstrap';
import Link from 'next/link';
import StyledButton from 'flaivy-react/components/StyledButton';

interface TextAndImageBlock {
  id: string;
  blockType: string;
  title: string;
  titleClassNames: string;
  text: string;
  textClassNames: string;
  backgroundColor: string;
  textColor: string;
  image: string;
  imageClassNames: string;
  buttonText: string;
  buttonLink: string;
  buttonClassNames: string;
}

const TextBlock = ({ block }: { block: TextAndImageBlock }) => {
  return (
    <div
      className="text-block p-5 d-flex flex-column justify-content-center"
      style={{
        backgroundColor: block?.backgroundColor || 'transparent',
      }}
    >
      {block.title && (
        <div className="w-100">
          <div
            style={{ color: block?.textColor || 'white' }}
            className={`fw-normal m-0 ${block.titleClassNames || 'display-6'}`}
          >
            {block?.title}
          </div>
        </div>
      )}
      <div className="text-block-text mt-2">
        {block.text && (
          <div
            style={{ color: block?.textColor || 'white' }}
            className={block.textClassNames}
            dangerouslySetInnerHTML={{
              __html: block?.text,
            }}
          />
        )}
        {block.buttonText && (
          <Link href={block?.buttonLink || '/'}>
            <StyledButton
              color="light"
              className={`mt-5 ${block.buttonClassNames}`}
            >
              {block?.buttonText}
            </StyledButton>
          </Link>
        )}
      </div>
    </div>
  );
};

const ImageBlock = ({ block }: { block: TextAndImageBlock }) => {
  return (
    <div
      className={`image-block ${block.imageClassNames}`}
      style={{
        backgroundImage: block?.image ? `url(${block?.image})` : 'none',
      }}
    ></div>
  );
};

function TextAndImageComponent({
  blockTextAndImage,
}: {
  blockTextAndImage: TextAndImageBlock;
}) {
  let imageClassNames = '';
  let textClassNames = '';
  if (blockTextAndImage.blockType === 'textImage') {
    imageClassNames += 'order-first order-md-last ps-md-0';
    textClassNames += 'order-last order-md-first pe-md-0';
  }
  if (blockTextAndImage.blockType === 'imageText') {
    imageClassNames += 'order-first pe-md-0';
    textClassNames += 'order-last ps-md-0';
  }

  return (
    <div className="block-text-and-image">
      <Row className="g-0">
        <Col xs={12} md={4} className={`${imageClassNames}`}>
          <ImageBlock block={blockTextAndImage} />
        </Col>
        <Col xs={12} md={8} className={` ${textClassNames}`}>
          <TextBlock block={blockTextAndImage} />
        </Col>
      </Row>
    </div>
  );
}

export default TextAndImageComponent;
